import React from 'react';

import { AccountMenuLoggedOutStateNav3 } from '../account-menu-logged-out-state/nav3';
import { AccountMenuTriggerNav3 } from '../account-menu-popup/account-menu-trigger/nav3';
import { AccountMenu, type AccountMenuProps } from './index';

/**
 * @deprecated Nav3 (`@atlaskit/atlassian-navigation`) support is being removed.
 * This will be removed from the default `@atlassian/account-menu` entrypoint and the `/nav3` entrypoints in the next major version.
 * Use the default export from `@atlassian/account-menu/nav4` instead.
 */
export const AccountMenuNav3 = (props: AccountMenuProps): React.JSX.Element => {
	return (
		<AccountMenu
			{...props}
			AccountMenuLoggedOutState={AccountMenuLoggedOutStateNav3}
			AccountMenuTrigger={AccountMenuTriggerNav3}
		/>
	);
};
